import { DirectiveOptions } from 'vue';

function isVisible(el: HTMLElement) {
    const { display, visibility } = window.getComputedStyle(el);
    return display !== 'none' && visibility !== 'hidden';
}

const directive: DirectiveOptions = {
    bind: function (el, binding, VNode) {
        // Provided expression must evaluate to a function.

        if (
            process.env.NODE_ENV !== 'production' &&
            typeof binding.value !== 'function'
        ) {
            const compName = (VNode.context as any)?.name;
            let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
            if (compName) {
                warn += `Found in component '${compName}'`;
            }

            console.warn(warn);
        }

        // Define Handler and cache it on the element
        const bubbleMod = binding.modifiers.bubble;
        const visibleMod = binding.modifiers.visible;
        const handler = (e: Event) => {
            const targetOk =
                bubbleMod ||
                (!el.contains((e as any).target) && el !== e.target);
            const visibilityOk = !visibleMod || isVisible(el);
            if (targetOk && visibilityOk) {
                binding.value(e);
            }
        };
        (el as any)['__vueClickoutside__'] = handler;

        // add Event Listeners
        document.addEventListener('click', handler);
        document.addEventListener('touchmove', handler);
    },

    unbind: function (el) {
        // Remove Event Listeners
        document.removeEventListener(
            'click',
            (el as any)['__vueClickoutside__']
        );
        document.removeEventListener(
            'touchmove',
            (el as any)['__vueClickoutside__']
        );
        (el as any)['__vueClickoutside__'] = null;
    },
};

export default directive;
